import React, { useEffect } from 'react';
import { Typography, Tag, Button, message } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import CrudPage from '../../../components/common/CrudPage';
import { heroscopService } from '../../../services/cms/contentManagementService';

const { Text } = Typography;

// Bắt buộc theo backend: 9 cột nội dung dưới đây là NOT NULL không default ở bảng `heroscop`;
// `date` đã được thêm required vào HeroscopVal. Riêng `damPhanThanhCong` trước đây KHÔNG có ô
// trên form nên nhập đủ mọi ô vẫn không tạo mới được (QA-09). Chỉ `soMayMan` cho phép rỗng.
const REQUIRED = [{ required: true }];

const formFields = [
  { name: 'tenCung', label: 'Tên cung', type: 'input', rules: REQUIRED },
  // Ô ngày trước là input chữ tự do — cùng khuôn lỗi `Incorrect date value` của Tử vi (QA-03)
  { name: 'date', label: 'Ngày', type: 'date', format: 'DD/MM/YYYY', submitFormat: 'YYYY-MM-DD', rules: REQUIRED },
  { name: 'dateTitle', label: 'Tiêu đề ngày', type: 'input', rules: REQUIRED },
  { name: 'tinhCam', label: 'Tình cảm', type: 'textarea', propsInput: { rows: 2 }, rules: REQUIRED },
  { name: 'suNghiep', label: 'Sự nghiệp', type: 'textarea', propsInput: { rows: 2 }, rules: REQUIRED },
  { name: 'theChat', label: 'Thể chất', type: 'textarea', propsInput: { rows: 2 }, rules: REQUIRED },
  { name: 'tamTrang', label: 'Tâm trạng', type: 'textarea', propsInput: { rows: 2 }, rules: REQUIRED },
  { name: 'mauMayMan', label: 'Màu may mắn', type: 'input', rules: REQUIRED },
  { name: 'saoHopCa', label: 'Sao hợp ca', type: 'input', rules: REQUIRED },
  { name: 'damPhanThanhCong', label: 'Đàm phán thành công', type: 'input', rules: REQUIRED },
  { name: 'soMayMan', label: 'Số may mắn', type: 'input' },
  { name: 'priority', label: 'Ưu tiên', type: 'number' },
  { name: 'public', label: 'Public', type: 'select', options: [{ label: 'Có', value: 1 }, { label: 'Không', value: 0 }], defaultValue: 1 },
];

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
  { title: 'TÊN CUNG', dataIndex: 'tenCung', key: 'tenCung', width: 150, render: (t) => <Text strong>{t}</Text> },
  { title: 'NGÀY', dataIndex: 'date', key: 'date', width: 120, render: (t) => t ? dayjs(t, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY') : '-' },
  { title: 'TÌNH CẢM', dataIndex: 'tinhCam', key: 'tinhCam', ellipsis: true, width: 200 },
  { title: 'SỰ NGHIỆP', dataIndex: 'suNghiep', key: 'suNghiep', ellipsis: true, width: 200 },
  { title: 'PUBLIC', dataIndex: 'public', key: 'public', width: 80, render: (p) => <Tag color={p === 1 ? 'green' : 'red'}>{p ? 'YES' : 'NO'}</Tag> },
  { title: 'NGƯỜI TẠO', dataIndex: 'author_name', key: 'author_name', width: 140, render: (val, r) => val || r.create_by || r.created_by || '-' },
  { title: 'CẬP NHẬT', dataIndex: 'updated_at', key: 'updated_at', width: 140, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
];

const filterFields = [
  {
    label: 'Ngày',
    value: 'date',
    type: 'date',
    // Thiếu submitFormat thì bộ lọc gửi 'DD/MM/YYYY' xuống cột heroscop.date kiểu DATE
    // -> MariaDB không so được, danh sách luôn rỗng (URL mặc định đã set date = hôm nay).
    submitFormat: 'YYYY-MM-DD',
  },
];

const QuanLyCungHoangDao = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.get('date') && !searchParams.has('date')) {
      const params = new URLSearchParams(searchParams);
      params.set('date', dayjs().format('DD/MM/YYYY'));
      setSearchParams(params, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  // Nút Thêm trước đây bị tắt (disableAdd) vì form thiếu ô `damPhanThanhCong` — cột NOT NULL
  // không default — nên tạo mới luôn lỗi DB. Form đã đủ 10 trường bắt buộc và HeroscopVal đã
  // khớp DB nên mở lại (QA-09). Muốn khoá lại thì thêm disableAdd={true} vào CrudPage.
  return (
    <CrudPage 
      title="QUẢN LÝ CUNG HOÀNG ĐẠO" 
      subTitle="Cung hoàng đạo hàng ngày" 
      itemsName="Cung" 
      queryKey="heroscopList" 
      service={heroscopService} 
      columns={columns} 
      formFields={formFields} 
      filterFields={filterFields} 
      searchPlaceholder="Tìm theo tên cung..." 
      extraActions={
        <Button icon={<SyncOutlined />} onClick={() => message.info('Đang chờ Backend cung cấp API đồng bộ Cung hoàng đạo')}>Reload</Button>
      }
      formConfig={{ width: 900 }} 
    />
  );
};
export default QuanLyCungHoangDao;
